// ==============================|| OVERRIDES - CARD CONTENT ||============================== //

export default function CardContent() {
  return {
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '12px 8px',
          '&:last-child': {
            paddingBottom: 8
          }
        }
      }
    }
  };
}
